<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/zb8ouC/tc-custom/9781439662953.jpg?1702539092919" alt="This image is the cover for the book Haunted Northwest Arkansas, Haunted America"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Haunted Northwest Arkansas, Haunted America
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Discover the tales of the ghosts and specters that linger in the northwest corner of the Natural State.</b></p> The mountains and deeply wooded valleys of Northwest Arkansas have a mysterious side to match their pristine beauty. Eureka Springs is home to more than a few hotel guests who have never checked out. The lingering spirits of fallen Civil War soldiers are said to haunt the battlefields of Pea Ridge and Prairie Grove. Many former patients of sadistic doctor Norman Baker are believed to roam the grounds of his former hospital, now the Crescent Hotel. Elkhorn Tavern, a well-known stop on the historic westward thoroughfare, is still plagued by lingering apparitions from its days as a field hospital. Join paranormal investigator and author Bud Steed on a tour of some of the most haunted spots in Northwest Arkansas.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bud Steed
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?49152f06